// 定制化router配置
const arr = [
  // 登录
  // {
  //   path: '/login',
  //   name: 'login',
  //   meta: {
  //     type: 'custom'
  //   },
  //   component: () => import('@/viewsCustom/login'),
  // },
  // 页面未匹配
  {
    path: '/error_500',
    name: 'error_500',
    component: () => import('@/viewsCustom/error_500'),
  },
  // 未登录
  {
    path: '/noLogin',
    name: 'noLogin',
    meta: {
      atName: 'noLogin'
    },
    component: () => import('@/viewsCustom/noLogin'),
  },
  // 未登录
  {
    path: '/noPermissions',
    name: 'noPermissions',
    meta: {
      atName: 'noPermissions'
    },
    component: () => import('@/viewsCustom/noPermissions'),
  },
]

export default arr